import { render } from "./dropdown.vue?vue&type=template&id=39564922&ts=true"
import script from "./dropdown.vue?vue&type=script&lang=ts"
export * from "./dropdown.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__